import { useRef, useEffect, useState } from 'react'
import { motion, useInView, useSpring, useTransform } from 'framer-motion'

const Counter = ({ value, label, suffix = "" }) => {
  const ref = useRef(null)
  const isInView = useInView(ref, { once: true })
  
  const springValue = useSpring(0, {
    stiffness: 40,
    damping: 20,
    restDelta: 0.001
  })

  const displayValue = useTransform(springValue, (latest) => 
    Math.round(latest).toLocaleString('fr-FR')
  )

  useEffect(() => {
    if (isInView) {
      springValue.set(value)
    }
  }, [isInView, value, springValue])

  return (
    <div ref={ref} className="text-center p-6">
      <div className="text-4xl md:text-5xl font-bold text-cidh-blue mb-2 font-montserrat flex justify-center items-center">
        <motion.span>{displayValue}</motion.span>
        <span>{suffix}</span>
      </div>
      <div className="text-cidh-gray-text font-medium uppercase tracking-wide text-sm">{label}</div>
    </div>
  )
}

const StatCounter = () => {
  const stats = [
    { value: 70, label: "Experts & Consultants", suffix: "+" },
    { value: 20, label: "Études réalisées", suffix: "+" },
    { value: 50, label: "Projets réalisés", suffix: "+" },
    { value: 18500, label: "Formation Professionnelle Continue (FPC)", suffix: "" },
  ]

  return (
    <section className="bg-cidh-gray-light py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, idx) => (
            <Counter key={idx} {...stat} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default StatCounter
